import React from 'react';
import { connect } from "react-redux";
import { UiActions } from 'state/actions/UiActions';
import { PartnerAdminActions } from 'state/actions/user/PartnerAdminActions';
import { GlamqueenCouponStyle } from 'components/admin/GlamqueenCouponStyle.scss';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';
import { Modal, Table } from '@material-ui/core';

export class GlamqueenCoupon extends React.Component {
  constructor(props) {

    super(props);

    this.props.isAdmin(
      this.props.person.person.username,
      (response) => {
        const isAdmin = response.result;
        if (!isAdmin) {
          props.history.push("/");
        }
      });

      this.state = {
        isModalVisible : false,
        message : String,
        errorMessage: String,
        couponName : String,
        request: []
      }
  }

  // create requistion POST
  createCoupon = async (e) => {

    e.preventDefault();

    const token = this.props.token.Authorization;

    let form = document.getElementById('couponForm');
    let userInfo = form.elements['user'].value;
    let couponInfo = form.elements['coupon'].value;
    let boostInfo = form.elements['boost'].checked;

    let endpoint = 'https://apiglamapp-prod.glambox.com.br' + GlamboxEndpoints.Partner.createGlamqueenCoupon.url;

    const requestBody = {
      name: couponInfo,
      userName: userInfo,
      boost:  boostInfo,
      active: '1'
    }
    
    fetch(
      endpoint,
      {
        "method":"POST",
        headers :{
          "content-type":"application/json",
          "Authorization": token},
        body: JSON.stringify(requestBody),
      })
      .then(response => response.json())
      .then((data)=>{

        console.log("success:", data);
        this.state.couponName = form.elements['coupon'].value;

        if(data.message == undefined){
          this.state.message = '✔️' + data.result.message;
          this.renderModal();
          this.couponsRequest();
        }else{
          this.state.message = '❌' +data.message;
          this.renderModal();
        }
      })
      .catch((error) => {
        console.log("Error:", error);
        this.state.message = error.message;
      })

  }

  // Result request modal 
  renderModal = async () =>{

    if ( this.state.couponName == String || this.state.isModalVisible == true){
      this.state.isModalVisible = false;
      this.state.couponName = String;
    }else{
      this.state.isModalVisible = true;
    }

    this.forceUpdate();

  }

  // Glamqueen coupons requisition
   couponsRequest = async () =>{

    const token = this.props.token.Authorization;

    let endpoint = 'https://apiglamapp-prod.glambox.com.br' + GlamboxEndpoints.Partner.glamqueenCoupon.url;

    var options = {
      'method': 'GET',
      'contentType': 'application/json',
    };

    options.headers = { 'Authorization': token}

    const data = [ await fetch(
      endpoint, 
      options
      )
    .then(response => response.json())];

    this.state.request = data[0].result;
      
    this.forceUpdate();

  }

  render() {  

    // Copy text button function 
    function copiarTexto() {
      let textoCopiado = document.getElementById("link");
      textoCopiado.select();
      textoCopiado.setSelectionRange(0, 99999)
      document.execCommand("copy");
      alert("Texto copiado!");
    }
    //--------------------------------------------------------

    // coupon link generator and log requisition massage
    const message = {
      resultMessage: this.state.message,
      link: ('sua.glambox.com.br/glamqueen2/?c=' + this.state.couponName)
    }
    //-----------------------------------------------------------------------------

    // requisition reponse modal
    const modal = () => {

      return (
        <Modal
          visible={this.state.isModalVisible}
          onClose={this.renderModal}
          open={this.renderModal}
        >
          <div className='responseModal'> 
            <label className='result'> {this.state.message}</label>
            <div className='placeModal'>
              <input type='text' id="link" className='link' defaultValue={message.link}/>
              <button className='copyLink' onClick={copiarTexto}></button>
            </div>
          </div> 
        </Modal>
      )
      
    }
    //---------------------------------------------------------------------------------------------

    // Renderize coupons table
    const DataTable = () =>{

      this.couponsRequest();

      return (
          <Table className={"couponTable"}>
          <thead>
            <tr >
              <th>Nome</th>
              <th>Cupom</th>
              <th>Ativo</th>
              <th>Data</th>
              <th>Impulsionamento</th>
            </tr>
          </thead>
          <tbody>
              { this.state.request.map(
                request =>{

                  const date = new Date(request.datecreated);

                  const format = date.getFullYear()+'-' + (date.getMonth()+1) + '-'+date.getDate();

                  let boost = String;

                  if(request.boost == true){
                     boost = 'Sim'; 
                  }else{
                     boost = 'Não';
                  }

                  let active = String;

                  if(request.active == 1){
                    active = 'Sim'; 
                  }else{
                    active = 'Não';
                  }

                  return(
                    <tr>
                      <td>{request.username}</td>
                      <td>{request.name}</td>
                      <td>{active}</td>
                      <td>{format}</td>
                      <td>{boost}</td>
                    </tr>
                  )
                
              })}
          </tbody>
        </Table>  
      )                                     

    }      
    //-----------------------------------------------------------------

    return (
      <section id="adminGlamqueenLanding">
        <main className="GlamqueenMain">

            <div className="adminMain">

              <div className="boxTitle">
                <label>Criar Cupom de Glamqueen</label>
              </div>  

              <div className="places">
                <form onSubmit={this.createCoupon} method="POST" id="couponForm">
                  <span className="legend">Nome da GQ:<input type="text" id="user" className="name" placeholder="Ex: Paula Sampaio" required/></span> 
                  <span className="legend">Nome do Cupom:<input type="text" id="coupon" className="name" placeholder="Ex: PAULASAMPAIO" required/></span>
                  <span className="legend2">Impulsionamento:<input type="checkbox" id="boost" className="boost" /></span>
                  <button className="cadastrar btn btn-pink">Cadastrar</button>
                </form>
              </div>

            </div>

            { this.state.isModalVisible ?  modal() : <div/>}

            <div className="couponList">
              
              <div className="boxTitle">
                <label>Cupons</label>
              </div>  

              {DataTable()}

            </div>


        </main>
      </section>
    );
  }

}

const mapStateToProps = (state) => ({
  store: state,
  person: state.person.data,
  partnerGeneral: state.partnerGeneral.data,
  token: state.token.data

});

const mapDispatchToProps = (dispatch) => ({
  loaderShow: () => {
    dispatch(UiActions.loaderShow());
  },
  loaderHide: () => {
    dispatch(UiActions.loaderHide());
  },
  publishSuccessAlert: (message) => {
    dispatch(UiActions.publishSuccessAlert(message));
  },
  publishErrorAlert: (message) => {
    dispatch(UiActions.publishErrorAlert(message));
  },
  isAdmin: (email, callback) => {
    dispatch(PartnerAdminActions.isAdmin(email, callback));
  }
});


GlamqueenCoupon = connect(
  mapStateToProps,
  mapDispatchToProps
)(GlamqueenCoupon);